import createApiInstance from './apiFactory';
import { ENV } from '@/config/env';

export const API_V3 = createApiInstance({
  baseURL: `${ENV.BACK_URL}/api_views/workflow/v3`,
  withCredentials: false,
});
